import { LazyQueryExecFunction, OperationVariables } from "@apollo/client";
import { TFunction } from "next-i18next";
import { Toast } from "../../../../components/TailwindControls/Toast";

export const handleDomainCheck = async (
  subdomain: string,
  checksubdomain: LazyQueryExecFunction<any, OperationVariables>,
  t: TFunction
) => {
  try {
    await checksubdomain({
      variables: { subdomain: subdomain.toLowerCase() },
    }).then((responseOnCompletion) => {
      if (!responseOnCompletion.data) return;
      if (!responseOnCompletion.data.checkSubdomain) return;
      if (!responseOnCompletion.data.checkSubdomain.messageKey) return;
      if (
        responseOnCompletion.data.checkSubdomain.messageKey ===
        "instance-subdomain-exists"
      ) {
        Toast.error(t("checkdomain-error"));
      }
    });
  } catch (error) {
    console.error(error);
  }
};
